import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerCorrispondenzaOrdinariaModalComponent} from './worker-corrispondenza.ordinaria-modal';


export const WorkerCorrispondenzaOrdinariaModalModule: string = ng
  .module('worker-corrispondenza-ordinaria-modal', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('workerCorrispondenzaOrdinariaModalComponent', WorkerCorrispondenzaOrdinariaModalComponent)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-corrispondenza-ordinaria-modal/worker-corrispondenza-ordinaria-modal.module.ts